var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIntercom = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F8DED",
    d: "M31.733 21.593a1.067 1.067 0 0 1-2.133 0V12a1.067 1.067 0 0 1 2.133 0zm-.372 6.677c-.165.141-4.116 3.457-11.361 3.457S8.804 28.411 8.64 28.27a1.067 1.067 0 0 1 1.385-1.622c.063.053 3.591 2.945 9.975 2.945 6.464 0 9.938-2.913 9.972-2.943a1.067 1.067 0 1 1 1.389 1.62M8.267 12a1.067 1.067 0 0 1 2.133 0v9.593a1.067 1.067 0 0 1-2.133 0zM13.6 9.867a1.067 1.067 0 0 1 2.133 0v14.25a1.067 1.067 0 0 1-2.133 0zm5.333-.54a1.067 1.067 0 1 1 2.134 0v15.466a1.067 1.067 0 1 1-2.134 0zm5.334.54a1.067 1.067 0 0 1 2.133 0v14.25a1.067 1.067 0 0 1-2.133 0zM32 4H8a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIntercom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/intercom.e842954f.svg";